import {MenuItemsType} from '@pancakeswap/uikit'
import {ContextApi} from '~/contexts/Localization/types'
import {hasCurrentWalletPermission, Permissions} from "~/utils/permissions";
import {AppMode} from "~/state/app/appModeSlice";
import {useAppMode} from "~/state/app/useAppMode";
import {useAccount} from "wagmi";

export type ConfigMenuItemsType = MenuItemsType & { hideSubNav?: boolean }

export function isAppMode(value: AppMode): boolean {
  const {appMode} = useAppMode()
  return appMode === value
}

const menuConfig: (t: ContextApi['t'], address: string, appMode: AppMode) => ConfigMenuItemsType[] = (t, address, appMode) => [
  ...(hasCurrentWalletPermission(address, [Permissions.STAFF]) && appMode === AppMode.SHIMMERSEA ?
    [
      {
        label: t('LP Claim'),
        href: '/lpburn',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ] : []),
  ...(hasCurrentWalletPermission(address, [Permissions.STAFF]) && appMode === AppMode.SHIMMERSEA ?
    [
      {
        label: t('LP Farm Stats'),
        href: '/lpoverview',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ] : []),
  ...(hasCurrentWalletPermission(address, [Permissions.STAFF]) && appMode === AppMode.SWAPLINE ?
    [{
      label: t('LP Claim'),
      href: '/lpclaim',
      icon: '',
      items: [],
      showItemsOnMobile: false,
    },
    ] : []),
  ...(hasCurrentWalletPermission(address, [Permissions.INVESTOR, Permissions.STAFF]) && appMode === AppMode.SHIMMERSEA ?
    [
      {
        label: t('Personal Claim'),
        href: '/personalclaim',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ] : []),
  ...(hasCurrentWalletPermission(address, [Permissions.INVESTOR, Permissions.STAFF]) && appMode === AppMode.SHIMMERSEA ?
    [
      {
        label: t('Personal Transactions'),
        href: '/personaltransactions',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ] : []),
  ...(hasCurrentWalletPermission(address, [Permissions.STAFF, Permissions.STATISTICS]) && appMode === AppMode.SWAPLINE ?
    [
      {
        label: t('LP Stats'),
        href: '/lpstats',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ] : []),
    ...[
      {
        label: t('Vaults'),
        href: '/vaults',
        icon: '',
        items: [],
        showItemsOnMobile: false,
      },
    ],
  /*
  {
    label: t('Pool'),
    icon: '',
    href: '/liquidity',
    videoLink: "https://images.shimmersea.finance/videos/trade_NAV.mp4",
    items: [
      {
        label: t('All Pools'),
        href: '/liquidity',
      },
      {
        label: t('My Liquidity'),
        href: '/myliquidity',
      },
    ],
  },
  {
    label: t('Earn'),
    href: '/farms',
    icon: '',
    videoLink: "https://images.shimmersea.finance/videos/earn_NAV.mp4",
    items: [
      {
        label: t('Farm'),
        href: '/farms',
      },
      {
        label: t('Stake'),
        href: '/pools',
      },
      {
        label: t('Boost'),
        href: '/boosters',
      },
    ],
  },
  {
    label: t('NFT'),
    href: `/nfts`,
    icon: '',
    items: [
      {
        label: t('Overview'),
        href: `/nfts`,
      },
      {
        label: t('Collections'),
        href: `/nfts/collections`,
      },
      {
        label: t('Activity'),
        href: `/nfts/activity`,
      },
    ],
  },
  {
    label: t('Stats'),
    href: '/stats',
    icon: '',
    showItemsOnMobile: false,
    items: [],
  },
  {
    label: t('Bridge'),
    href: '/bridge',
    icon: '',
    showItemsOnMobile: false,
    items: [],
  },
  {
    label: '',
    href: '/fairlaunch',
    icon: 'More',
    hideSubNav: true,
    videoLink: "https://images.shimmersea.finance/videos/info_NAV.mp4",
    items: [
      {
        label: t('Fairlaunch'),
        href: '/fairlaunch',
      },

      {
        label: t('Lumis'),
        href: '/LumiLanding',
        icon: '',
        items: [
          {
            label: t('Collecting'),
            href: '/LumiLanding',
          },
          {
            label: t('My Lumis'),
            href: '/NftMyWhitelist',
          },
        ],
      },

      {
        label: t('Blog'),
        href: 'https://medium.com/@shimmerseadefi',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
      {
        label: t('Whitepaper'),
        href: 'https://nein_lieber_dr_diese_seite_gibt_es_nicht_aber_ich_brauch_kein_bugticket_.de',
        type: DropdownMenuItemType.EXTERNAL_LINK,
      },
    ],
  },*/
]

const config = {
  menuConfig,
  showMLUM: true,
  showLUM: true,
  showSMR: true
}

export default config
